<ng-container *ngFor="let author of authors; let i = index;">
  <a (click)="openAuthorBio(author.id)" href="#" *ngIf="link">{{author.name}}</a>
  <span *ngIf="!link">{{author.name}}</span>
  <ng-container *ngIf="i < authors.length - 1">, </ng-container>
</ng-container>
